// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardTemplateUserAssignment\ApiTopicCardTemplateUserAssignment.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { TopicCardTemplate, TopicCardTemplateData, TopicCardTemplateOptions } from 'data/models/TopicCardTemplate';

// TopicCardTemplateUserAssignmentData is the class that TopicCardTemplateUserAssignment serializes to/from
export interface TopicCardTemplateUserAssignmentData {
    TemplateId : number;
    Url : string | null;
    UserId : number;
	
    Template : TopicCardTemplateData | null;
    User : PCUserData | null;
	
}

// TopicCardTemplateUserAssignmentOptions is the class which may be passed to the TopicCardTemplateUserAssignment constructor to define optional initial data values
export interface TopicCardTemplateUserAssignmentOptions {
    TemplateId : number;
    Url? : string | null;
    UserId : number;
	
    Template? : TopicCardTemplateOptions | null;
    User? : PCUserOptions | null;
	
}

export class TopicCardTemplateUserAssignment {
    public TemplateId : DataSignal<number>;
    public Url : DataSignal<string | null>;
    public UserId : DataSignal<number>;
	
    public Template : DataSignal<TopicCardTemplate | null>;
    public User : DataSignal<PCUser | null>;
	

    constructor();
    constructor(data : TopicCardTemplateUserAssignmentOptions);
    constructor(data: TopicCardTemplateUserAssignmentOptions | null = null) {
        this.TemplateId = jsonableObservable(S.value<number>(data && data.TemplateId !== undefined ? data.TemplateId : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.Template = S.value<TopicCardTemplate | null>(null);
        this.User = S.value<PCUser | null>(null);
	    
    }

    static key(obj : TopicCardTemplateUserAssignment) {
        return obj.TemplateId() + '\u2618' + obj.UserId();
    }
    
    static dataKey(obj : TopicCardTemplateUserAssignmentOptions) {
        return obj.TemplateId + '\u2618' + obj.UserId;
    }

    static update(obj : TopicCardTemplateUserAssignment, data : TopicCardTemplateUserAssignmentOptions) {
        S.freeze(() => {
            if (data.TemplateId !== undefined) obj.TemplateId(data.TemplateId);
            if (data.Url !== undefined) obj.Url(data.Url);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardTemplateUserAssignment.ts